import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";

/**
 * Hook de Tipos de Leads
 * - Lista principal: usa tree=1 (retorna roots + até 3 níveis de children)
 * - Subtipos por id_pai: usa o parâmetro correto `parent_id`
 * - Mutations: POST/PUT/DELETE padrão
 */
export const useTypes = (page = 1, limit = 100, search = "") => {
  const queryClient = useQueryClient();

  // === Query principal: ÁRVORE ===
  const query = useQuery(
    ["types", page, limit, search],
    () =>
      fetchData(
        `/types?tree=1&page=${page}&limit=${limit}&search=${encodeURIComponent(
          search
        )}`
      ),
    {
      // Catálogo muda pouco; cache maior evita refetchs duplicados no boot
      staleTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
      select: (response) => ({
        types: (response.data || []).map(t => ({
          ...t,
          allowed_positions: Array.isArray(t.allowed_positions) ? t.allowed_positions : []
        })),
        pagination: response.pagination || { total: 0 },
      }),
    }
  );

  // === Hook auxiliar: lista flat por id_pai ===
  const useFetchSubtypes = (idPai) => {
    return useQuery(
      ["subtypes", idPai],
      () => fetchData(`/types?parent_id=${idPai}`).then((res) => res.data || []),
      {
        enabled: !!idPai,
        staleTime: 5000,
        refetchOnWindowFocus: false,
      }
    );
  };

  // === Mutations padrão ===
  const updateMutation = useMutation(
    (type) => {
      const method = type.id ? "PUT" : "POST";
      const endpoint = type.id ? `/types/${type.id}` : `/types`;
      return fetchData(endpoint, method, type);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("types");
      },
    }
  );

  const deleteMutation = useMutation(
    (id) => fetchData(`/types/${id}`, "DELETE"),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("types");
      },
    }
  );

  return { ...query, useFetchSubtypes, updateMutation, deleteMutation };
};
